import * as React from "react";
import {
  Navigate
} from 'react-router-dom';
function NoMatch() {
  return (<Navigate to="login"/>);
}

export default NoMatch;
